export const prefix = '[All / Learning Paths]';
